import React, { FC } from "react";
import { Tooltip, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

export interface BurnSootIndexAdornmentProps {
  value: number;
}

export const BurnSootIndexAdornment: FC<BurnSootIndexAdornmentProps> = (
  props
) => {
  const { t } = useTranslation("firefly-shared-ts-domain");
  return (
    <Tooltip title={t("Soot Index")} arrow placement={"top-start"}>
      <Typography>{props.value.toFixed(1)}</Typography>
    </Tooltip>
  );
};
